export default "__VITE_ASSET__ad735e2a__$_?component__"